// Assign user roles
export * from "./assignUserRoles.component";
export * from "./assignUserRoles.service";



// WEBPACK FOOTER //
// ./src/app/modules/userHome/applicationAccess/assignUserRoles/index.ts